import Breadcrumb, { BreadcrumbLink } from "components/common/Breadcrumb";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import apifetch from "utils/apifetch";
import downloadResponse from "utils/downloadResponse";

interface State {
    isSubmitting: boolean;
    includeLegacy: boolean;
}

export default class Products extends React.Component<
    RouteComponentProps<{}>,
    State
> {
    constructor(props: RouteComponentProps<{}>) {
        super(props);

        this.state = {
            isSubmitting: false,
            includeLegacy: false,
        };

        this.handleBooleanInputChanged = this.handleBooleanInputChanged.bind(this);
        this.handleView = this.handleView.bind(this);
    }

    public componentDidMount() {
        document.title = "Item Catalog - Reports - " + SITE_NAME;
    }

    public render() {
        return (
            <div className="container">
                <div className="animated fadeIn">
                    <Breadcrumb>
                        <BreadcrumbLink to="/">Home</BreadcrumbLink>
                        <BreadcrumbLink to="/reports">Reports</BreadcrumbLink>
                        <BreadcrumbLink isActive={true}>Item Catalog</BreadcrumbLink>
                    </Breadcrumb>
                    <div className="box-wrap">
                        <div className="card-block">
                            <h3 className="block-title">Item Catalog</h3>
                            <div className="form-wrapper">
                                <div className="row">
                                    <div className="field-group col-sm-6 mt-2 mb-2">
                                        <span className="field-label mt-0">Include Legacy</span>
                                        <p className="custom-checkbox-wrap">
                                            <input
                                                className="custom-checkbox"
                                                id="include-legacy-yes"
                                                name="includeLegacy"
                                                type="radio"
                                                value="true"
                                                onChange={this.handleBooleanInputChanged}
                                                checked={this.state.includeLegacy}
                                            />
                                            <label htmlFor="include-legacy-yes">Yes</label>
                                        </p>
                                        <p className="custom-checkbox-wrap">
                                            <input
                                                className="custom-checkbox"
                                                id="include-legacy-no"
                                                name="includeLegacy"
                                                type="radio"
                                                value="false"
                                                onChange={this.handleBooleanInputChanged}
                                                checked={!this.state.includeLegacy}
                                            />
                                            <label htmlFor="include-legacy-no">No</label>
                                        </p>
                                    </div>
                                </div>
                                <div className="form-actions">
                                    <div className="button-actions text-center">
                                        {this.state.isSubmitting ? (
                                            <button
                                                className="btn btn-primary"
                                                onClick={this.handleView}
                                            >
                                                <i className="icon-spinner icon-pulse"></i> Generating
                                            </button>
                                        ) : (
                                            <button
                                                className="btn btn-primary"
                                                onClick={this.handleView}
                                                disabled={this.state.isSubmitting}
                                            >
                                                View
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private handleBooleanInputChanged(
        event: React.SyntheticEvent<HTMLInputElement>
    ) {
        this.setState({
            [event.currentTarget.name]: event.currentTarget.value === "true",
        } as any);
    }

    private async handleView(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();

        this.setState({
            isSubmitting: true,
        });

        event.preventDefault();

        let response = await apifetch(
            `reports/products?includeLegacy=${this.state.includeLegacy}`,
            undefined,
            true
        );
        downloadResponse(response);

        this.setState({
            isSubmitting: false,
        });
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/reports/Products.tsx